import * as React from "react";

/**
 * Trailing-edge debounce: returns `value` only after `delay` ms of no further
 * changes. Right boundary for talking to the backend on a fast-changing form.
 */
export function useDebouncedValue<T>(value: T, delay = 100): T {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
